import React, { useState } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { ActiveCell } from "../GridComponents";
import { EditCommandCell, SignatureCell } from "../GridComponents";
import { useDocTypes, updateDocType } from "services/docTypeService";
import EditDocType from "./EditDocTypes";
import { GridLoader } from "components/GridLoader";

const DocTypeList = () => {
  const { data: docTypes, loading } = useDocTypes();
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const enterEdit = (item) => {
    setEditItem(item);
    setOpenForm(true);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    try {
      const result = await updateDocType(event.docRegisterTypeID, {
        code: event.code,
        typeName: event.typeName,
        active: event.active,
      });
      if (result.success) {
        setOpenForm(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="settings-grid-wrapper h-100">
      <div className="settings-grid h-100">
        <Grid
          data={docTypes}
          style={{ height: "100%", width: "max-content", maxWidth: "100%" }}
          showLoader={loading}
          loader={
            <div style={{ height: "50px" }}>
              <GridLoader />
            </div>
          }>
          <GridNoRecords>
            {loading ? (
              <span></span>
            ) : (
              docTypes && docTypes?.length === 0 && "No records available"
            )}
          </GridNoRecords>
          <Column title=" " field="code" cell={SignatureCell} width="80" />
          <Column field="code" title="Code" width="100" />
          <Column field="typeName" title="Name" width="180" />
          <Column cell={ActiveCell} title="Active" width="60" />
          <Column
            title=" "
            cell={(props) => <EditCommandCell {...props} enterEdit={enterEdit} />}
            width="50"
          />
        </Grid>
      </div>

      {openForm && (
        <EditDocType
          item={editItem}
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
          cancelEdit={() => setOpenForm(false)}
        />
      )}
    </div>
  );
};

export default DocTypeList;
